import { postData } from '../utils/ajax-utils';
import { PredefinedCartConstructor } from './predefined-cart-constructor';

export function initCart() : void {
    const $cartForm = document.querySelector<HTMLFormElement>('.js-cart-form');

    if ($cartForm) {
        new CartForm($cartForm);
    }
}

type AddToCartEventType = {
    cart: {
        total: number,
        products: (typeof paymentDetail.services),
    },
    product?: (typeof paymentDetail.services)[0],
};

declare global {
    interface DocumentEventMap {
        'add_to_cart': CustomEvent<AddToCartEventType>;
    }
}

class CartForm {
    $form: HTMLFormElement;
    $quantityModifiers: NodeListOf<HTMLSelectElement>;
    $deleteButtons: NodeListOf<HTMLButtonElement>;
    $partnerCode: HTMLInputElement|null;
    $partnerCodeBtn: HTMLButtonElement|null;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$quantityModifiers = this.$form.querySelectorAll<HTMLSelectElement>('.js-quantity-modifier');
        this.$deleteButtons = this.$form.querySelectorAll<HTMLButtonElement>('.js-product-delete-button');

        this.$quantityModifiers.forEach($quantityModifier => {
            const initialQuantity = parseInt($quantityModifier.value);

            $quantityModifier.addEventListener('change', () => {
                const $container = $quantityModifier.closest('.js-product') as HTMLElement;
                const newQuantity = parseInt($quantityModifier.value);
                const itemKey = $quantityModifier.dataset.itemKey || '';

                const args = {
                    action: 'get_cart_with_new_item_quantity',
                    item_key: itemKey,
                    new_quantity: newQuantity.toString(),
                };

                postData(scriptVar.ajaxUrl, args).then(response => {
                    // Dispatch an event with new new cart items detail
                    document.dispatchEvent(new CustomEvent('add_to_cart', {
                        detail: {
                            cart: {
                                total: response.data.cart.total,
                                products: response.data.cart.services,
                            },
                            product: {
                                name: $container.dataset.productName,
                                ref: $container.dataset.productRef,
                                price: $container.dataset.price,
                                type: $container.dataset.type,
                                duration: $container.dataset.duration,
                                face_to_face: $container.dataset.faceToFace,
                                optional_product: $container.dataset.optionalProduct,
                                quantity: newQuantity - initialQuantity,
                            },
                        },
                    }));

                    $container.querySelector<HTMLButtonElement>('.js-update-cart-item')?.click();
                }).catch(error => {
                    console.error('Error:', error);
                });
            });
        });

        this.$deleteButtons.forEach($deleteButton => {
            $deleteButton.addEventListener('click', evt => {
                if ($deleteButton.classList.contains('wait') && $deleteButton.classList.contains('js-product-delete-button-waiting')) {
                    evt.preventDefault();
                    return;
                }

                // If the button contains the class, prevent the submission and perform ajax request
                // Finally, remove the class and simulate a second click on this button
                if ($deleteButton.classList.contains('js-product-delete-button-waiting')) {
                    evt.preventDefault();

                    const itemKey = $deleteButton.dataset.itemKey || '';

                    const args = {
                        action: 'get_cart_with_new_item_quantity',
                        item_key: itemKey,
                        new_quantity: '0',
                    };

                    postData(scriptVar.ajaxUrl, args).then(response => {
                        // Dispatch an event with new new cart items detail
                        document.dispatchEvent(new CustomEvent('add_to_cart', {
                            detail: {
                                cart: {
                                    total: response.data.cart.total,
                                    products: response.data.cart.services,
                                },
                            },
                        }));
                    }).catch(error => {
                        console.error('Error:', error);
                    }).finally(() => {
                        // Simulate a second click on this button without the class
                        $deleteButton.classList.remove('js-product-delete-button-waiting');
                        $deleteButton.click();
                    });
                }
            });
        });

        this.$partnerCode = this.$form.querySelector<HTMLInputElement>('.js-partner-code-input');
        this.$partnerCodeBtn = this.$form.querySelector<HTMLButtonElement>('.js-partner-code-submit');

        // Click on apply button when pressing the Enter key into partner code input
        if (this.$partnerCode) {
            this.$partnerCode.addEventListener('keypress', evt => {
                if ('Enter' === evt.key) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    
                    this.$partnerCodeBtn?.click();
                }
            });
        }

        const $predefinedCartContainer = this.$form.querySelector<HTMLElement>('.js-predefined-cart');
        if ($predefinedCartContainer) {
            new PredefinedCartConstructor(this.$form, $predefinedCartContainer);
        }
    }
}
